import styled from "styled-components";

export const Overlay = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: ${({ $zIndex }) => $zIndex};
  background-color: rgba(0, 0, 0, 0.5);
  pointer-events: none;
`;

export const Modal = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${({ $zIndex }) => $zIndex};
`;

export const ModalContent = styled.div`
  padding: 24px 36px;
  background-color: var(--card-hover);
  border-radius: 8px;
  max-width: 480px;
  width: 100%;

  @media (max-width: 428px) {
    max-width: 328px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const Body = styled.div`
  display: flex;
  gap: 8px;
  justify-content: space-between;
`;
